import { Menu } from './menu.model';
import { RoleEnum } from '../../enums';

export const verticalMenuItems = [
  new Menu(1, 'MENU.HOME', '/home', null, 'home', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Employee,
    RoleEnum.Provider,
  ]),
  // new Menu(2, 'MENU.DASHBOARD', '/dashboard', null, 'dashboard', null, false, 0, [RoleEnum.Admin]),
  new Menu(2, 'MENU.SETTINGS', null, null, 'more_horiz', null, true, 0, [RoleEnum.Admin]),
  new Menu(3, 'MENU.EMPLOYEES', '/employees', null, 'supervisor_account', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Employee,
  ]),
  // new Menu(4, 'MENU.SETTINGS', '/settings', null, 'settings', null, false, 0, [RoleEnum.Admin]),
  new Menu(4, 'MENU.PROVIDERS', '/providers', null, 'menu_book', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Employee,
  ]),
  new Menu(5, 'MENU.CITIZENS', '/citizens', null, 'menu_book', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Employee,
  ]),
  new Menu(6, 'MENU.FIELDS', '/fields', null, 'golf_course', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Provider,
  ]),
  new Menu(7, 'MENU.REGIONS', '/regions', null, 'location_on', null, false, 2, [RoleEnum.Admin]),
  new Menu(8, 'MENU.FIELDS_SIZES', '/field-size', null, 'aspect_ratio', null, false, 2, [
    RoleEnum.Admin,
  ]),
  new Menu(9, 'MENU.FIELDS_TYPES', '/field-type', null, 'category', null, false, 2, [
    RoleEnum.Admin,
  ]),
  new Menu(10, 'MENU.ADS', '/panels', null, 'slideshow', null, false, 0, [RoleEnum.Admin]),
  new Menu(11, 'MENU.APPLICATION_SETTINGS', '/settings', null, 'settings_suggest', null, false, 2, [
    RoleEnum.Admin,
  ]),
  new Menu(12, 'MENU.PROGRAMS', '/academies', null, 'school', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Provider,
  ]),
  new Menu(13, 'MENU.RESERVATIONS', '/reservations', null, 'date_range', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Provider,
  ]),
  new Menu(14, 'MENU.PROGRAM_SPORTS', '/program-sports', null, 'sports', null, false, 2, [
    RoleEnum.Admin,
  ]),
  new Menu(
    15,
    'MENU.PROGRAM_RESERVATIONS',
    '/program-reservations',
    null,
    'date_range',
    null,
    false,
    0,
    [RoleEnum.Admin, RoleEnum.Employee, RoleEnum.Provider]
  ),
  new Menu(16, 'MENU.CLOSED_SLOTS', '/closed-slots', null, 'lock_clock', null, false, 0, [
    RoleEnum.Provider,
  ]),
  new Menu(
    17,
    'MENU.COMPOUND_CITIZEN',
    '/citizens/compound-citizen',
    null,
    'supervisor_account',
    null,
    false,
    0,
    [RoleEnum.Provider]
  ),
  new Menu(
    18,
    'MENU.CITIZENS',
    '/citizens/provider-citizens',
    null,
    'supervisor_account',
    null,
    false,
    0,
    [RoleEnum.Provider]
  ),
  new Menu(19, 'MENU.SCHEDULE', '/schedule', null, 'calendar_today', null, false, 0, [
    RoleEnum.Provider,
    RoleEnum.Admin,
  ]),

  new Menu(20, 'MENU.PROVIDER_BRANCHES', '/branches', null, 'location_on', null, false, 0, [
    RoleEnum.Admin,
    RoleEnum.Provider,
    RoleEnum.Employee,
  ]),
];
